const REGEX = /(\@\@\{)(.*)(\})/
export default {
  methods: {
    validate () {
      if(this.$refs[this._uid]) {
        this.$refs[this._uid].$emit('submitEvent', this.modelProps)
      }
    },
    expressionResolver (object) {
      let cloneObject = object
      if(typeof cloneObject === 'string') {
        if (REGEX.test(cloneObject)) {
          let fullMatch = REGEX.exec(cloneObject)
          if(fullMatch) {
            let value = fullMatch[2]
            cloneObject = cloneObject.replace(fullMatch[0], eval(value))
          }
        }
      }
      for (let key in cloneObject) {
        if (typeof cloneObject[key] === 'object') {
          cloneObject[key] = this.expressionResolver(cloneObject[key])
        } else {
          if (REGEX.test(cloneObject[key])) {
            let fullMatch = REGEX.exec(cloneObject[key])
            if(fullMatch) {
              let value = fullMatch[2]
                cloneObject[key] = cloneObject[key].replace(fullMatch[0], eval(value))
            }
          }
        }
      }
      return cloneObject
    }
  }
}
